// import LogbookMonitoring from "src/pages/LogbookMonitoring/LogbookMonitoringList";
// import ProgressReportInterview from "src/pages/LogbookMonitoring/ProgressReportInterview";
import InterviewScheduleCreate from "src/pages/LogbookMonitoring/InterviewScheduleCreate";
import PerformanceEvaluation from "src/pages/LogbookMonitoring/PerformanceEvaluation";

import ProgressReport from "src/pages/LogbookMonitoring/ProgressReport";
import ProgressReportInterview from "src/pages/LogbookMonitoring/ProgressReportInterview";
import ScheduleListForITMC from "src/pages/LogbookMonitoring/ScheduleListForITMC";
import SupervisorActivityLog from "src/pages/LogbookMonitoring/SupervisorActivityLog";
import TraineeActivityLog from "src/pages/LogbookMonitoring/TraineeActivityLog";
import TraineeListForSixMonthReport from "src/pages/LogbookMonitoring/TraineeListForSixMonthReport";
import TraineesScheduleList from "src/pages/LogbookMonitoring/TraineesScheduleList";


export const logBookMonitoringRoutes = [
  // { path: '/monitoring-list', component: LogbookMonitoring },
  { path: '/progress-report-interview', component: ProgressReportInterview },
  { path: '/performance-evaluation/:regNo/:id/:name/:trainingId/:sessionId', component: PerformanceEvaluation },
  { path: '/six-monthly-report', component: TraineeListForSixMonthReport },
  { path: '/progress-report', component: ProgressReport },
  { path: '/trainee-activity-log', component: TraineeActivityLog },
  { path: '/supervisor-activity-log', component: SupervisorActivityLog },

  { path: '/interview-schedule-create', component: InterviewScheduleCreate },
  { path: '/trainee-schedule-list/:id', component: TraineesScheduleList },
  { path: '/schedule-list-for-itmc', component: ScheduleListForITMC },
];
